import { twMerge } from 'tailwind-merge';
import type { UnisonProjectTypeId } from '@witmetrics/utils';
import { UNISON_PROJECT_TYPE_ID } from '@witmetrics/utils/constants';
import { PROJECT_TYPE_COLORS } from '@witmetrics/unison-core';
import Icon from '@/components/Icon';
import { ICONS } from './constants';
import { classes } from './utils';

const { OTHER } = UNISON_PROJECT_TYPE_ID;

export type CaseTypeIconProps = {
  className?: string;
  iconClassName?: string;
  projectTypeId?: UnisonProjectTypeId;
};

export default function CaseTypeIcon({
  className,
  iconClassName,
  projectTypeId,
}: CaseTypeIconProps) {
  const colors =
    PROJECT_TYPE_COLORS[projectTypeId || OTHER] || PROJECT_TYPE_COLORS[OTHER];

  const CaseIcon = ICONS[projectTypeId || OTHER] || ICONS[OTHER];

  return (
    <Icon
      className={twMerge(classes.wrapper, className)}
      icon={<CaseIcon className={twMerge(classes.icon, iconClassName)} />}
      color="white"
      borderColor={null}
      backgroundColor={colors.fill}
    />
  );
}
